import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { TerminePage } from './pages/TerminePage';
import { MediathekPage } from './pages/MediathekPage';
import { KontaktPage } from './pages/KontaktPage';
import { ImpressumPage } from './pages/ImpressumPage';
import { DatenschutzPage } from './pages/DatenschutzPage';
import { AGBPage } from './pages/AGBPage';
import { CourseDetailPage } from './pages/CourseDetailPage';
import { SpeakerDetailPage } from './pages/SpeakerDetailPage';
import { IntensivCurriculumPage } from './pages/IntensivCurriculumPage';
import { KurseOverviewPage } from './pages/KurseOverviewPage';
import { ReferentenOverviewPage } from './pages/ReferentenOverviewPage';
import { BookingProvider } from './contexts/BookingContext';
import { BookingModal } from './components/BookingModal';
export function App() {
  return <BookingProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
          <Route path="/termine" element={<TerminePage data-id="element-6" />} data-id="element-5" />
          <Route path="/mediathek" element={<MediathekPage data-id="element-8" />} data-id="element-7" />
          <Route path="/kontakt" element={<KontaktPage data-id="element-10" />} data-id="element-9" />
          <Route path="/impressum" element={<ImpressumPage data-id="element-12" />} data-id="element-11" />
          <Route path="/datenschutz" element={<DatenschutzPage data-id="element-14" />} data-id="element-13" />
          <Route path="/agb" element={<AGBPage data-id="element-16" />} data-id="element-15" />
          <Route path="/kurse" element={<KurseOverviewPage data-id="element-18" />} data-id="element-17" />
          <Route path="/kurse/intensiv-curriculum" element={<IntensivCurriculumPage data-id="element-20" />} data-id="element-19" />
          <Route path="/kurse/:slug" element={<CourseDetailPage data-id="element-22" />} data-id="element-21" />
          <Route path="/referenten" element={<ReferentenOverviewPage data-id="element-24" />} data-id="element-23" />
          <Route path="/referenten/:slug" element={<SpeakerDetailPage data-id="element-26" />} data-id="element-25" />
        </Routes>
      </BrowserRouter>
      <BookingModal data-id="element-27" />
    </BookingProvider>;
}